import React from 'react';
import { ThreeCircles } from 'react-loader-spinner';
import './Loader.css';

const Loader = ({ size = 100 }) => {
  return (
    <div className="loader-container">
      <ThreeCircles
        visible={true}
        height={size}
        width={size}
        color="red"
        ariaLabel="three-circles-loading"
        wrapperStyle={{}}
        wrapperClass=""
      />
    </div>
  );
};

export default Loader; 